import * as Sentry from "@sentry/browser";
import splitbee from "@splitbee/web";

export const identify = (user: Record<string, string | number>) => {
  Sentry.setUser(user);
  splitbee.user.set(user);
};
